import { render, staticRenderFns } from "./goHome.vue?vue&type=template&id=032c9925&scoped=true&"
import script from "./goHome.vue?vue&type=script&lang=js&"
export * from "./goHome.vue?vue&type=script&lang=js&"
import style0 from "./goHome.vue?vue&type=style&index=0&id=032c9925&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c9925",
  null
  
)

export default component.exports